import { create } from "zustand";

interface SessionState {
  status: "idle" | "authenticating" | "authenticated" | "not_registered" | "error";
  playerId: string | null;
  worldId: number | null;
  telegramId: number | null;
  displayName: string | null;
  errorMessage: string | null;
  setAuthenticating: () => void;
  setAuthenticated: (data: {
    playerId: string;
    worldId: number;
    telegramId: number;
    displayName: string | null;
  }) => void;
  setNotRegistered: (telegramId: number) => void;
  setError: (message: string) => void;
  reset: () => void;
}

export const useSession = create<SessionState>((set) => ({
  status: "idle",
  playerId: null,
  worldId: null,
  telegramId: null,
  displayName: null,
  errorMessage: null,
  setAuthenticating: () => set({ status: "authenticating", errorMessage: null }),
  setAuthenticated: ({ playerId, worldId, telegramId, displayName }) =>
    set({
      status: "authenticated",
      playerId,
      worldId,
      telegramId,
      displayName,
      errorMessage: null,
    }),
  setNotRegistered: (telegramId) =>
    set({ status: "not_registered", telegramId, errorMessage: null }),
  setError: (message) => set({ status: "error", errorMessage: message }),
  reset: () =>
    set({
      status: "idle",
      playerId: null,
      worldId: null,
      telegramId: null,
      displayName: null,
      errorMessage: null,
    }),
}));
